// angular import
import { Component, ViewChild, ElementRef } from '@angular/core';
// importing the superclass
import { Module } from './../module.component';
// services import
import { Status } from './../../service/status.service';
import { LotService } from './lot.service';
// models import
import { LotRequest } from '../../model/lot/lot_request.model';
import { LotResponse } from '../../model/lot/lot_response.model';
// managers
import * as _ from 'underscore';
// components
import { ModalLotCharactsComponent } from '../MODAL-lot-characts/modal-lot-characts.component';

// component definition
@Component({
  selector: 'app-lot',
  templateUrl: './lot.component.html',
  providers:
    [
      LotService
    ]
})
export class LotComponent extends Module {

  // input values
  lot_number =                                          '';

  lot_request =                                         new LotRequest();
  lot_response =                                        new LotResponse();

  // form object values
  @ViewChild('lot_num_form') lot_num_form:            ElementRef;

  constructor(private lotService:                       LotService,
              private status:                           Status) {
    super();
    this.setBindExposer(this.status.getExposer());
    this.getExposer().getModelsManager().lot_request;

    this.setFormEnable(this.getCustomizingService().getBoolean('LOT.LIST.FORM.ENABLE', false));
    this.setAutoSearchEnable(this.getCustomizingService().getBoolean('LOT.LIST.AUTOSEARCH.ENABLE', false));

    this.requestModelSetUp();
    if (this.getAutoSearchEnable()) {
      this.doSearch();
    }
    // check for the IFRS triggers
    if (this.getIFRS().getHomeFunctions().FLAG_statefulLot) {
      this.lot_number = this.getIFRS().getHomeFunctions().getState_lot_number;
      this.doSearch();
      this.getIFRS().getHomeFunctions().FLAG_statefulLot = false;
    }
  }

  // set up the request model
  requestModelSetUp() {
    this.getModelsManager().lot_request.company_code = this.getAccountService().getUserCompany().code;
    this.getModelsManager().lot_request.supplier_code = this.getAccountService().supplierProperties.supplier_code;
    this.getModelsManager().lot_request.language = this.getLocale().getPreferredLanguage();
    this.lot_number = '';
  }

  // send the query to the server
  doSearch() {
    this.getModelsManager().lot_request.lot_number = this.lot_number;
    this.lotService.searchLots();
    this.showSearchParameters = false;
  }

  // method that handles the change of the lot number field
  updateLotNumber() {
    this.lot_number = this.lot_num_form.nativeElement.value;
    this.getModelsManager().lot_request.lot_number = this.lot_number;
    this.getIFRS().getHomeFunctions().getState_lot_number = this.lot_number;
  }

  // clear the input values
  clearFormValues() {
    this.lot_number = '';
    this.getIFRS().getHomeFunctions().getState_lot_number = '';
    this.requestModelSetUp();
  }

  // return true if service is stil searching
  isServiceSearching() {
    return this.lotService.isSearching();
  }

  // returns the status of the server query
  isResultEmpty() {
    return this.lotService.getLots().length === 0;
  }

  // returns the response model
  getLotServiceResponse() {
    return this.getOrderedList(this.lotService.getLots(), this.sortType, this.sortReverse);
  }

  downloadExcel() {
    this.lotService.downloadExcel(this.getAccountService().getUserCompany().code,
                                  this.getAccountService().supplierProperties.supplier_code,
                                  this.getLocale().getPreferredLanguage());
  }

  // returns normalized date
  getNormalDate(value) {
    if (value !== null && value !== undefined) {
      const date = new Date(value);
      this.getDateTimeManager().setDate(date);
      const text = this.getDateTimeManager().ddmmyyyy('/');
      return text;
    } else {
      return '';
    }
  }

  // shows the modal of the lot's characteristics
  showCharacts(modal: ModalLotCharactsComponent, lotNumber) {
    modal.setCharacts(lotNumber, this.getLocale().getPreferredLanguage());
    modal.show();
  }

  // go to material list filtered by suplier code and material code
  getMaterialByLot(supplier_code, material_code) {
    console.log('Codice Fornitore: ' + supplier_code);
    console.log('Codice Materiale: ' + material_code);
    // clear the data
    this.getIFRS().clearAllFunctionsData();
    // set the flag and the data
    this.getIFRS().getLotFunctions().FLAG_getMaterial = true;
    this.getIFRS().getLotFunctions().getMaterial_supplier_code = supplier_code;
    this.getIFRS().getLotFunctions().getMaterial_material_code = material_code;
    // switch the page
    this.getIFRS().getSidebar().setMenuItem('material_list');
  }

  // shows the modal of the lot's characteristics
  downloadPdf(lotNumber) {
    this.lotService.downloadPdf(lotNumber);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/lot/lot.component.ts